<div class="role-based-navigations">
    <button
        class="rolebased-button"
        (click)="showMyProfile(consts.PROFILE_REPORTS.MY_PROFILE.label)"
        [class.active]="activeHeaderIndex === consts.PROFILE_REPORTS.MY_PROFILE.index"
    >
        {{consts.PROFILE_REPORTS.MY_PROFILE.label}}
    </button>
<ng-container *ngIf="((isManager$ | async) || (isEMSreport)) else greyoutRole" >
    <button
        class="rolebased-button"
        (click)="showMyProfile(consts.PROFILE_REPORTS.MY_ROLE.label)"
        [class.active]="activeHeaderIndex === consts.PROFILE_REPORTS.MY_ROLE.index"
    >
        {{consts.PROFILE_REPORTS.MY_ROLE.label}}
    </button>
</ng-container>
<ng-template #greyoutRole>
    <button
        class="rolebased-button-inactive"       
    >
        {{consts.PROFILE_REPORTS.MY_ROLE.label}}
    </button>
</ng-template>
    <span *ngIf="regionNames$ | async as regionNames"></span>
    <button
       class="rolebased-button"  
       (click)="showMyProfile(consts.PROFILE_REPORTS.MY_REGION.label)" 
       [class.active]="activeHeaderIndex === consts.PROFILE_REPORTS.MY_REGION.index"
       [disabled]="disabledRegionButton"
    >
        {{consts.PROFILE_REPORTS.MY_REGION.label}}
    </button>
</div>

<ng-container *ngIf="myRole">
    <div class="work-profile-myrole" [ngClass]="isTeamsApp ? 'teams-app-info' : ''">
        <h6 *ngIf="isTeamsApp">{{consts.PROFILE_REPORTS.TITLE_MYTEAM}}</h6>
        <p *ngIf="isTeamsApp">{{messageManager}}</p>
        <button
            class="report-button"
            (click)="showPowerBIReport(consts.PROFILE_REPORTS.ACCOUNT_EXECUTIVE.label)"
            [class.active]="activeIndex === consts.PROFILE_REPORTS.ACCOUNT_EXECUTIVE.index"
            [ngClass]="isTeamsApp ? 'ems-btn-align' : ''"
            *ngIf="isEMSreport"
        >
            {{consts.PROFILE_REPORTS.ACCOUNT_EXECUTIVE.label}}   
        </button>
        <button
            class="report-button"
            [ngClass]="isTeamsApp ? 'hide-info-teams' : ''"
            (click)="showPowerBIReport(consts.PROFILE_REPORTS.MY_TEAM.label)"
            [class.active]="activeIndex === consts.PROFILE_REPORTS.MY_TEAM.index"
            appTooltip="{{consts.TOOLTIP_MIG_BUTTON}}"
            tooltipPosition="top"
            *ngIf="isManager$ | async as isManager"
        >
            {{consts.PROFILE_REPORTS.MY_TEAM.label}}        
        </button>
        <div class="teams-app-info work-profile-navigations" *ngIf="isTeamsApp">
            <button 
                class="report-button" 
                (click)="redirectPBIreportURL()"
                appTooltip="{{consts.TOOLTIP_MIG_BUTTON}}"
                tooltipPosition="top"
            >
                <mat-icon svgIcon="hub_profile_managers"></mat-icon>
                {{consts.PROFILE_REPORTS.MY_TEAM.label}}
            </button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="myProfile">
    <div class="teams-app-info work-profile-navigations" *ngIf="isTeamsApp">
        <h6>{{consts.PROFILE_REPORTS.TITLE_PROFILE}}</h6>
        <p>{{consts.PROFILE_REPORTS.MESSAGE_PROFILE}}</p>
        <button class="report-button" (click)="redirectPBIreportURL()"><mat-icon svgIcon="hub_profile_projects"></mat-icon>{{consts.PROFILE_REPORTS.PROJECTS.label}}</button>
        <button class="report-button" (click)="redirectPBIreportURL()"><mat-icon svgIcon="hub_profile_time"></mat-icon>{{consts.PROFILE_REPORTS.TIMETRACKING.label}}</button>
        <button class="report-button" (click)="redirectPBIreportURL()"><mat-icon svgIcon="hub_profile_skills"></mat-icon>{{consts.PROFILE_REPORTS.SKILLS.label}}</button>
    </div>
    <div class="work-profile-navigations" [ngClass]="isTeamsApp ? 'hide-info-teams' : ''">
        <button
            class="report-button"
            (click)="showPowerBIReport(consts.PROFILE_REPORTS.PROJECTS.label)"
            [class.active]="activeIndex === consts.PROFILE_REPORTS.PROJECTS.index"
        >
            {{consts.PROFILE_REPORTS.PROJECTS.label}}
        </button>
        <button
            class="report-button"
            (click)="showPowerBIReport(consts.PROFILE_REPORTS.TIMETRACKING.label)"
            [class.active]="activeIndex === consts.PROFILE_REPORTS.TIMETRACKING.index"
        >
            {{consts.PROFILE_REPORTS.TIMETRACKING.label}}
        </button>
        <button
            class="report-button"
            (click)="showPowerBIReport(consts.PROFILE_REPORTS.SKILLS.label)"
            [class.active]="activeIndex === consts.PROFILE_REPORTS.SKILLS.index"
        >
            {{consts.PROFILE_REPORTS.SKILLS.label}}
        </button>
    </div>
</ng-container>

<ng-container *ngIf="myRegion">
    <div class="my-region">  
        <div class="region-banner-holder" *ngFor="let regionList of regionList">
            <img  class="region-banner" src='{{regionList.imagepath}}'>
            <div class="caption">
                {{regionList.region.concat(' Region')}}
            </div>
        </div>    
        <div class="region-container">
            <label class="region-content" *ngFor="let thumbnail of thumbnailList">
                <div>    
                    <div class="title">
                        {{thumbnail.title}}
                    </div>
                    <a 
                        href='{{thumbnail.link}}'
                        target="_blank"
                    >
                        {{thumbnail.link}}
                    </a>
                    <a 
                        href='{{thumbnail.link}}'
                        target="_blank"
                    >
                        <img  class="thumbnail" src='{{thumbnail.thumbnailpath}}'>
                    </a>

                    <div class="link-menu">
                        <div [matMenuTriggerFor]="menu">
                            <mat-icon svgIcon="hub_more_horiz"></mat-icon>
                        </div>
                    <mat-menu #menu="matMenu">
                        <button
                            mat-menu-item
                            class="mat-menu-option"
                            (click)="openLink(thumbnail.link)"
                            appInsightsTrack
                            [eventData]=regionLists
                            loc="{{consts.TITLE}}"
                            action="Open link"
                        >
                            <mat-icon
                                class="menu-icon"
                                svgIcon="hub_folder_icon"
                            >
                            </mat-icon>
                            <span>{{consts.ACTION_OPEN}}</span>
                        </button>
                        <button
                            mat-menu-item
                            class="mat-menu-option"
                            ngxClipboard
                            [cbContent]="thumbnail.link"
                            (click)="openSnackBar()"
                            appInsightsTrack
                            [eventData]=thumbnailList
                            loc="{{consts.TITLE}}"
                            action="{{consts.ACTION_COPY_LINK}}"
                        >
                            <mat-icon
                                class="menu-icon"
                                svgIcon="hub_link"
                            >
                            </mat-icon>
                            <span>{{consts.ACTION_COPY_LINK}}</span>
                        </button>
                    </mat-menu>
                    </div>
                </div>
            </label> 
            <!-- <label  class="region-content">
                <div *ngFor="let workplaceList of workplaceLists">   
                    <div class="title">
                        {{workplaceList.caption}}
                    </div>
                    <a 
                        href='{{workplaceList.link}}'
                        target="_blank"
                    >
                        {{workplaceList.link}}
                    </a>
                    <a 
                        href='{{workplaceList.link}}'
                        target="_blank"
                    >
                        <img  class="thumbnail" src='{{workplaceList.thumbnailpath}}'>   
                    </a>
                    <div class="link-menu">
                        <div [matMenuTriggerFor]="menu">
                            <mat-icon svgIcon="hub_more_horiz"></mat-icon>
                        </div>
                        <mat-menu #menu="matMenu">
                            <button
                                mat-menu-item
                                class="mat-menu-option"
                                (click)="openLink(workplaceList.link)"
                                appInsightsTrack
                                [eventData]=workplaceLists
                                loc="{{consts.TITLE}}"
                                action="Open link"
                            >
                                <mat-icon
                                    class="menu-icon"
                                    svgIcon="hub_folder_icon"
                                >
                                </mat-icon>
                                <span>{{consts.ACTION_OPEN}}</span>
                            </button>
                            <button
                                mat-menu-item
                                class="mat-menu-option"
                                ngxClipboard
                                [cbContent]="workplaceList.link"
                                (click)="openSnackBar()"
                                appInsightsTrack
                                [eventData]=rs
                                loc="{{consts.TITLE}}"
                                action="{{consts.ACTION_COPY_LINK}}"
                            >
                                <mat-icon
                                    class="menu-icon"
                                    svgIcon="hub_link"
                                >
                                </mat-icon>
                                <span>{{consts.ACTION_COPY_LINK}}</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </label>  -->
        </div>   
    </div>
</ng-container>
<div id="reportContainer" [ngClass]="(isTeamsApp && !isEMSreport) || (isTeamsApp && myProfile) ? 'hide-info-teams' : ''"></div>
<div class="hidden" id="authContainer"></div>
